import { AppConfigurationType } from "types/apps";
import Failure from "./index.component";

const failure: AppConfigurationType = {
    Component: Failure,
    precondition: async () => true,
}

export default failure;